import Vue from 'vue';
import Router from 'vue-router';
import { store } from '@/store/store';

Vue.use(Router);

// Components
// import Home from '@/components/Home';
// import Login from '@/components/Login';
// import Logout from '@/components/Logout';
// import Invoices from '@/components/Invoices';
// import InvoiceLines from '@/components/InvoiceLines.vue';
// import Recipes from '@/components/Recipes';
// import RecipeDetail from '@/components/RecipeDetail';
// import Products from '@/components/Products';
// import ProductDetail from '@/components/ProductDetail';
// import Settings from '@/components/Settings';
// import Suppliers from '@/components/Suppliers';
// import Data from '@/components/Data';

const Home           = () => import('@/components/Home');
const Login          = () => import('@/components/Login');
const Logout         = () => import('@/components/Logout');
const Invoices       = () => import('@/components/Invoices');
const InvoiceLines   = () => import('@/components/InvoiceLines.vue');
const Recipes        = () => import('@/components/Recipes');
const RecipeDetail   = () => import('@/components/RecipeDetail');
const RecipeEbay   = () => import('@/components/RecipeEbay');
const Products       = () => import('@/components/Products');
const ProductsNew    = () => import('@/components/ProductsNew');
const ProductDetail  = () => import('@/components/ProductDetail');
const Batches        = () => import('@/components/Batches');
const BatchNew       = () => import('@/components/BatchNew');
const BatchDetail    = () => import('@/components/BatchDetail');
const Settings       = () => import('@/components/Settings');
const Suppliers      = () => import('@/components/Suppliers');
const Printers       = () => import('@/components/Printers');
const Data           = () => import('@/components/Data');
const Orders         = () => import('@/components/OrdersBatch');
const OrdersImport   = () => import('@/components/ImportOrder');
const OrderDetail    = () => import('@/components/OrderBatchDetail');
const OrdersP        = () => import('@/components/Orders');
const OrderPDetail   = () => import('@/components/OrderDetail');
const Customers      = () => import('@/components/Customers');
// const CustomerDetail = () => import('@/components/CustomerDetail');
const CustomerOrders = () => import('@/components/CustomerOrders');
const Trays          = () => import('@/components/Trays');
const Users          = () => import('@/components/Users');
const Reports        = () => import('@/components/Reports');

// Labels
const LabelsProducts    = () => import('@/components/labels/Products');
const LabelsProductsTwo = () => import('@/components/labels/ProductsTwo');
const LabelsTrays       = () => import('@/components/labels/Trays');
const LabelsRecipes     = () => import('@/components/labels/Recipes');

// Reports
const ReportNewCustomers         = () => import('@/components/Reports/new_customers.vue');
const ReportCustomerTypes        = () => import('@/components/Reports/customer_types.vue');
const ReportStockLevels          = () => import('@/components/Reports/stock_levels.vue');
const ReportSoldByType           = () => import('@/components/Reports/product_sold_by_type.vue');
const ReportTrayProducts         = () => import('@/components/Reports/products_by_tray.vue');
const ReportTrayBatches          = () => import('@/components/Reports/batches_by_tray.vue');
const ReportProductsProduced     = () => import('@/components/Reports/products_produced.vue');
const ReportCustomersByDateRange = () => import('@/components/Reports/customers_by_date_range.vue');
const ReportSubsequentOrders     = () => import('@/components/Reports/subsequent_orders.vue');
const ReportLapsedCustomers      = () => import('@/components/Reports/lapsed_customers.vue');
const ReportReOrders             = () => import('@/components/Reports/reorders.vue');
const ReportCoupons              = () => import('@/components/Reports/coupons.vue');

const ReportStockLevelsB      = () => import('@/components/Reports/stock_levels_b.vue');
const ReportSoldByTypeB       = () => import('@/components/Reports/product_sold_by_type_b.vue');
const ReportBatchesProduced   = () => import('@/components/Reports/batches_produced.vue');


const requireAuth = function(to, from, next){
  // console.log('Is Auth?', store.getters.is_authenticated);
  if(!store.getters.is_authenticated){
    next({
      path  : '/login',
      query : { redirect : to.fullPath }
    })
  } else {
    next()
  }
}

export default new Router({
  routes: [
    {
      path      : '/login',
      name      : 'Login',
      component : Login,
      meta        : {
        title : 'Log in'
      }
    },
    {
      path      : '/logout',
      name      : 'Logout',
      component : Logout
    },
    {
      path        : '/',
      name        : 'Home',
      component   : Home,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Home'
      }
    },
    {
      path        : '/reports/new_customers',
      name        : 'New Customers Report',
      component   : ReportNewCustomers,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - New Customers'
      }
    },
    {
      path        : '/reports/customer_types',
      name        : 'Customer Types Report',
      component   : ReportCustomerTypes,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Customer Types'
      }
    },
    {
      path        : '/reports/products_produced',
      name        : 'Products Produced Report',
      component   : ReportProductsProduced,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Products Produced'
      }
    },
    {
      path        : '/reports/product_sold_by_type',
      name        : 'Products Sold By Type Report (old)',
      component   : ReportSoldByType,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Products Sold By Type'
      }
    },
    {
      path        : '/reports/stock_levels',
      name        : 'Stock Level Report (old)',
      component   : ReportStockLevels,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Stock Levels'
      }
    },
    {
      path        : '/reports/batches_produced',
      name        : 'Batches Produced Report',
      component   : ReportBatchesProduced,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Batches Produced'
      }
    },
    {
      path        : '/reports/product_sold_by_type_b',
      name        : 'Products Sold By Type Report',
      component   : ReportSoldByTypeB,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Products Sold By Type'
      }
    },
    {
      path        : '/reports/stock_levels_b',
      name        : 'Stock Level Report',
      component   : ReportStockLevelsB,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Stock Levels'
      }
    },
    {
      path        : '/reports/customer_orders',
      name        : 'Customers with orders by date range report',
      component   : ReportCustomersByDateRange,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Customers with orders by date range'
      }
    },
    {
      path        : '/reports/subsequent_orders',
      name        : 'Customers with subsequent orders',
      component   : ReportSubsequentOrders,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Customers with subsequent orders'
      }
    },
    {
      path        : '/reports/lapsed_customers',
      name        : 'Customers not ordered for two months',
      component   : ReportLapsedCustomers,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Customers not ordered for two months'
      }
    },
    {
      path        : '/reports/reorders',
      name        : 'Re-Orders',
      component   : ReportReOrders,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Re-Orders'
      }
    },
    {
      path        : '/reports/coupons',
      name        : 'Coupons',
      component   : ReportCoupons,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Coupons'
      }
    },
    // {
    //   path        : '/reports/subsequent_orders/:customer_id',
    //   name        : 'Customers recent orders',
    //   component   : ReportSubsequentOrders,
    //   beforeEnter : requireAuth,
    //   meta        : {
    //     title : 'Report - Customers with subsequent orders'
    //   }
    // },
    {
      path        : '/reports',
      name        : 'Reports',
      component   : Reports,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Reports'
      }
    },
    {
      path        : '/trays/:id/products',
      name        : 'Products by tray',
      component   : ReportTrayProducts,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Products by Tray'
      },
    },
    {
      path        : '/trays/:id/batches',
      name        : 'Batches by tray',
      component   : ReportTrayBatches,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Report - Batches by Tray'
      },
    },
    {
      path        : '/trays/:id?',
      name        : 'Trays',
      component   : Trays,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Trays'
      },
    },
    {
      path        : '/customers/:id',
      name        : 'Customer',
      // component   : CustomerDetail,
      component   : CustomerOrders,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Customer'
      }
    },
    {
      path        : '/customers',
      name        : 'Customers',
      component   : Customers,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Customers'
      }
    },
    {
      path        : '/orders/import',
      name        : 'Import Order',
      component   : OrdersImport,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Import Order'
      }
    },
    {
      path        : '/orders',
      name        : 'Orders',
      component   : Orders,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Orders'
      },
      children : [
        {
          path        : ':id',
          name        : `orderdetail`,
          component   : OrderDetail,
          meta        : {
            title : 'Order'
          }
        }
      ]
    },
    {
      path        : '/ordersp',
      name        : 'Orders - Products',
      component   : OrdersP,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Orders - Products'
      },
      children : [
        {
          path        : ':id',
          component   : OrderPDetail,
          meta        : {
            title : 'Order'
          }
        }
      ]
    },
    {
      path        : '/products/new',
      name        : 'New Products',
      component   : ProductsNew,
      beforeEnter : requireAuth,
      meta        : {
        title : 'New Products'
      }
    },
    {
      path        : '/products',
      name        : 'Products',
      component   : Products,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Products'
      },
      children : [
        {
          path        : ':product_number',
          component   : ProductDetail,
          meta        : {
            title : 'Product'
          }
        }
      ]
    },
    {
      path        : '/batches/new',
      name        : 'New Batch',
      component   : BatchNew,
      beforeEnter : requireAuth,
      meta        : {
        title : 'New Batch'
      }
    },
    {
      path        : '/batches',
      name        : 'Batches',
      component   : Batches,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Batches'
      },
      children : [
        {
          path        : ':batch_number',
          component   : BatchDetail,
          meta        : {
            title : 'Batch'
          }
        }
      ]
    },
    {
      path        : '/recipes',
      name        : 'Recipes',
      component   : Recipes,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Recipes'
      },
      children : [
        {
          path        : ':id',
          component   : RecipeDetail,
          meta        : {
            title : 'Recipe'
          }
        },
        {
          path        : ':id/ebay',
          component   : RecipeEbay,
          meta        : {
            title : 'Recipe - eBay'
          }
        }
      ]
    },
    {
      path        : '/users',
      name        : 'Users',
      component   : Users,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Users'
      }
    },
    {
      path        : '/settings',
      name        : 'Settings',
      component   : Settings,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Settings'
      },
      children : [
        {
          path        : 'suppliers',
          component   : Suppliers,
          meta        : {
            title : 'Suppliers'
          }
        },
        {
          path        : 'printers',
          component   : Printers,
          meta        : {
            title : 'Printers'
          }
        },
        {
          path        : ':data_type',
          component   : Data
        }
      ]
    },
    {
      path        : '/invoices',
      name        : 'Invoices',
      component   : Invoices,
      beforeEnter : requireAuth,
      meta        : {
        title : 'Invoices'
      },
      children    : [
        {
          path      : ':id/:invoice_number',
          component : InvoiceLines,
          meta        : {
            title : 'Invoices'
          }
        }
      ]
    },
    {
      path        : '/labels/products',
      name        : 'ProductLabels',
      component   : LabelsProductsTwo,
      meta        : {
        title : 'Product labels'
      }
    },
    {
      path        : '/labels/productstwo',
      name        : 'ProductLabelsTwo',
      component   : LabelsProducts,
      meta        : {
        title : 'Product labels'
      }
    },
    {
      path        : '/labels/recipes',
      name        : 'RecipeLabels',
      component   : LabelsRecipes,
      meta        : {
        title : 'Recipe labels'
      }
    },
    {
      path        : '/labels/trays',
      name        : 'TrayLabels',
      component   : LabelsTrays,
      meta        : {
        title : 'Tray labels'
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js